/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
import { writable, get } from 'svelte/store';

export const filterMenu = writable(true);

export const toggleFilterMenu = () => {
  filterMenu.update(menu => (menu = !menu));
};

export const getFilterMenu = () => {
  return get(filterMenu);
};
